import { User } from 'firebase/auth';
import { onSnapshot, collection, where, orderBy, query } from 'firebase/firestore';

import { firestore } from '~/firebase/init';

import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { OrderType } from '~/types/common';
import { endOfOrderStatus, inProgressStatus } from '~/types/order';

export function ordersListener(
  auth: User,
  platformId: string,
  onNext: CollectionSnapShotFn,
  enterpriseGroupBuyId?: string,
) {
  const ref = collection(firestore, `platformOrders`);

  const q = [
    enterpriseGroupBuyId ? where('enterpriseGroupBuyId', '==', enterpriseGroupBuyId) : [],
  ].flat();

  const queryRef = query(
    ref,
    where('platform.id', '==', platformId),
    where('customer.uid', 'array-contains', auth.uid),
    where('type', '==', OrderType.PLATFORM_PICKUP_POINT),
    where('status', 'in', inProgressStatus),
    orderBy('createdAt', 'desc'),
    ...q,
  );

  return onSnapshot(queryRef, {
    next: onNext,
    error: (err) => {
      console.error('listen orders error', err);
    },
  });
}

export function pastOrderListener(
  auth: User,
  platformId: string,
  onNext: CollectionSnapShotFn,
  enterpriseGroupBuyId?: string,
) {
  const ref = collection(firestore, `platformOrders`);

  const q = [
    enterpriseGroupBuyId ? where('enterpriseGroupBuyId', '==', enterpriseGroupBuyId) : [],
  ].flat();

  const queryRef = query(
    ref,
    where('platform.id', '==', platformId),
    where('customer.uid', 'array-contains', auth.uid),
    where('type', '==', OrderType.PLATFORM_PICKUP_POINT),
    where('status', 'in', endOfOrderStatus),
    ...q,
    orderBy('pickMealAt', 'desc'),
  );

  return onSnapshot(queryRef, {
    next: onNext,
    error: (err) => {
      console.error('listen past orders error', err);
    },
  });
}
